import * as React from 'react';
import { isNil } from 'lodash';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Spinner from 'components/spinner/Spinner';
import CampaignPayoutsHeaderInfo from 'modules/campaigns/components/payments/payouts/header-info/CampaignPayoutsHeaderInfo';
import SubcampaignPayoutsHeaderVariable from './variable/SubcampaignPayoutsHeaderVariable';

import { isOther } from 'utils/subcampaign';
import { getPaymentInfo } from 'utils/payouts';
import { isInfluencersFocusedOrganizationRejected } from 'utils/organization';
import { __t, applyTranslations } from 'utils/language';

import './subcampaign-payouts-header.scss';

import type { BrandProfile, Campaign, Organization, Subcampaign, VariablePayment } from 'types';
import type { Dispatch } from 'redux';

applyTranslations(require('./subcampaign-payouts-header.i18n.json'));

type OwnProps = {
  campaign: Campaign,
  subcampaign: Subcampaign,
  hasPayouts: boolean,
  variablePayments: Array<VariablePayment>,
  variablePaymentsAmount: number,
  isLoading: boolean
};

type StateProps = {
  brandProfile: BrandProfile,
  currentOrganization: Organization
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by redux connect
} & OwnProps & StateProps;

class SubcampaignPayoutsHeader extends React.PureComponent<Props> {
  renderButtons = (): JSX.Element => {
    const { campaign, subcampaign } = this.props;

    return (
      <div className="subcampaign-payouts-header__button">
        <ActionButton
          link={`/campaigns/${campaign.id}/details/${subcampaign.id}/messages`}
          data={{ qa: 'subcampaign-payouts-header__button--message-brand' }}
        >
          {__t('subcampaign_payouts_header.button_message_brand')}
        </ActionButton>
      </div>
    );
  };

  renderPayoutExpected = (): JSX.Element => (
    <div className="subcampaign-payouts-header__payout-info">
      <div className="subcampaign-payouts-header__payout-info-text">
        <span className="subcampaign-payouts-header__payout-info-label">
          {__t('subcampaign_payouts_header.label_payout_expected')}:&nbsp;
        </span>
        <span>
          {__t('subcampaign_payouts_header.label_not_yet_released')}
        </span>
      </div>
    </div>
  );

  render(): React.ReactNode {
    const {
      campaign,
      subcampaign,
      variablePayments,
      variablePaymentsAmount,
      hasPayouts,
      isLoading,
      brandProfile,
      currentOrganization
    } = this.props;

    if (isLoading) {
      return (
        <section
          className="subcampaign-payouts-header"
          data-qa="subcampaign-payouts-header"
        >
          <div className="subcampaign-payouts-header__spinner">
            <Spinner
              position="inline"
              size="small"
              color="light"
            />
          </div>
        </section>
      );
    }

    const otherArrangement = isOther(subcampaign);
    const paymentInfo = getPaymentInfo(subcampaign, otherArrangement, variablePayments);

    if (isNil(campaign) || isNil(subcampaign)) {
      return null;
    }

    const isInfluencerProfileRejected = isInfluencersFocusedOrganizationRejected(currentOrganization);

    return (
      <section
        className="subcampaign-payouts-header"
        data-qa="subcampaign-payouts-header"
      >
        <CampaignPayoutsHeaderInfo
          profile={brandProfile}
          paymentInfo={paymentInfo}
          otherArrangement={otherArrangement}
        />
        <div className="subcampaign-payouts-header__offer">
          <SubcampaignPayoutsHeaderVariable
            campaignName={campaign.name}
            paymentInfo={paymentInfo}
            variablePayments={variablePayments}
            variablePaymentsAmount={variablePaymentsAmount}
            otherArrangement={otherArrangement}
          />
        </div>
        <div className="subcampaign-payouts-header__payments">
          {
            !hasPayouts && (
              this.renderPayoutExpected()
            )
          }
          {
            !isInfluencerProfileRejected && (
              this.renderButtons()
            )
          }
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ brandProfile, organizations }): StateProps => ({
  brandProfile: brandProfile.profile,
  currentOrganization: organizations.currentOrganization
});

export default connect(mapStateToProps)(SubcampaignPayoutsHeader);
